import type { Backend } from '@freelancer/datastore/core';
import {
  OrderByDirection,
  getQueryParamValue,
} from '@freelancer/datastore/core';
import { isDefined } from '@freelancer/utils';
import type { BusinessBuilderAttemptCollection } from './business-builder-attempt.types';

export function businessBuilderAttemptBackend(): Backend<BusinessBuilderAttemptCollection> {
  return {
    defaultOrder: {
      direction: OrderByDirection.DESC,
      field: 'id',
    },
    fetch: (authUid, ids, query) => {
      const workspaceIds = getQueryParamValue(query, 'workspaceId');
      return {
        endpoint: `business-builder/attempt.php`,
        method: 'GET',
        isGaf: true,
        params: {
          workspaceId: workspaceIds.length === 1 ? workspaceIds[0] : undefined,
          id: ids?.[0] ?? undefined,
          workspaceIds: workspaceIds.length > 1 ? workspaceIds : undefined,
        },
      };
    },
    push: (authUid, businessBuilderAttempt) => ({
      endpoint: `business-builder/attempt.php`,
      method: 'POST',
      isGaf: true,
      payload: {
        id: businessBuilderAttempt.id,
        intendedPaymentAmount: businessBuilderAttempt.intendedPaymentAmount,
        phaseIndex: businessBuilderAttempt.phaseIndex,
        phasesData: businessBuilderAttempt.phasesData,
        projectCount: businessBuilderAttempt.projectCount,
      },
    }),
    set: undefined,
    update: (authUid, businessBuilderAttempt) => {
      if (!isDefined(businessBuilderAttempt.id)) {
        throw new Error(
          'Unsupported operation, Needs attempt id to update attempt',
        );
      }

      return {
        endpoint: `business-builder/attempt.php`,
        method: 'PUT',
        isGaf: true,
        payload: {
          userId: parseInt(authUid, 10),
          workspaceId: businessBuilderAttempt.workspaceId,
          transactionId: businessBuilderAttempt.transactionId,
          id: businessBuilderAttempt.id,
          phasesData: businessBuilderAttempt.phasesData,
        },
      };
    },
    remove: undefined,
  };
}
